import React from "react";
import withCustomStyles from "./BreadcrumbsPart.style";
import BreadcrumbsListPart from "./BreadcrumbsListPart";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import BreadcrumbsListSchemaPart from "./BreadcrumbsListSchemaPart";
import Skeleton from "react-loading-skeleton";

@inject(["categoriesStore"])
@observer
class BreadcrumbsPart extends React.Component {
  render() {
    const {
      props: {
        categoriesStore,
        cid,
        isSiteMap,
        isProductDetailPage,
        classes,
        productName,
        subtitle,
        aside
      }
    } = this;
    const categoryName = categoriesStore.find(cid).name;
    const loading =
      (categoriesStore.all.length === 0 || !categoryName) &&
      categoriesStore.state === "fetching";

    if (loading) {
      return (
        <div className={classes.root} aria-hidden="true">
          <Skeleton height={16} width={220} />
          {!isProductDetailPage && <Skeleton height={36} width={180} />}
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <BreadcrumbsListPart
          productName={productName}
          isSiteMap={isSiteMap}
          categories={categoriesStore.parents(cid)}
        />
        {!isProductDetailPage && (
          <div className={classes.titleRow}>
            <div className={classes.titles}>
              <h1 className={classes.title}>{categoryName}</h1>
              {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
            </div>
            {aside}
          </div>
        )}
        <BreadcrumbsListSchemaPart categories={categoriesStore.parents(cid)} />
      </div>
    );
  }
}

BreadcrumbsPart.propTypes = {
  cid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // shown under the H1, e.g. "24 products"
  subtitle: PropTypes.node,
  // right side of the title row, e.g. the sort control
  aside: PropTypes.node
};

export default withRouter(withCustomStyles(BreadcrumbsPart));
